import { ToastBodyProps } from '@globalmed/atlas-ui';
import { isAxiosError } from 'axios';

/**
 * Handles Axios errors and displays an appropriate toast notification.
 * - If the error has a response with `error_description` or `message`, it will silently return.
 * - If the error is a network error, displays a network-related message.
 * - If another Axios error occurs, displays the error message or a generic fallback.
 * - For non-Axios errors, displays a generic unknown error message.
 * @param error - The error to handle (may or may not be an AxiosError).
 * @param setToast - Function to set a toast notification with error details.
 */
export const handleAxiosError = (
  error: unknown,
  setToast: (toast: ToastBodyProps) => void,
) => {
  if (isAxiosError(error)) {
    if (error.response) {
      const message =
        error.response.data?.error_description || error.response.data?.message;
      if (message) return;
    } else if (error.code === 'ERR_NETWORK') {
      setToast({
        title: 'Network error. Please check your internet connection.',
        variant: 'error',
      });
      return;
    } else {
      setToast({
        title: error.message || 'An unexpected error occurred.',
        variant: 'error',
      });
      return;
    }
  }

  setToast({
    title: 'An unknown error occurred.',
    variant: 'error',
  });
};
